import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/typeahead-match.class";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";

@Component({
  selector: "app-layout",
  templateUrl: "./metalayoutnew.component.html",
  styleUrls: ["./metalayoutnew.component.scss"],
})
export class MetaLayoutNewComponent implements OnInit {
  buttonList = JSON.parse(` [
    {
        "name": "Edit",
        "buttontype": "common",
        "actiontype": "View",
        "attributes": {
            "recordtypeexists": "",
            "displaytype": "Button",
            "updateurl": "",
            "cloneurl": "",
            "returnurl": "",
            "targeturl": "api/v1/getWebPageLayout"
        }
    },
    {
        "name": "Delete",
        "buttontype": "common",
        "actiontype": "View",
        "attributes": {
            "recordtypeexists": "",
            "displaytype": "Button",
            "updateurl": "",
            "cloneurl": "",
            "returnurl": "web/v1/lead/leadlist",
            "targeturl": "api/v1/contact/delete"
        }
    },
    {
        "name": "Clone",
        "buttontype": "common",
        "actiontype": "View",
        "attributes": {
            "recordtypeexists": "",
            "displaytype": "Button",
            "updateurl": "",
            "cloneurl": "",
            "returnurl": "",
            "targeturl": "api/v1/getWebPageLayout"
        }
    },
    {
      "name": "Edit",
      "buttontype": "common",
      "actiontype": "View",
      "attributes": {
          "recordtypeexists": "",
          "displaytype": "Button",
          "updateurl": "",
          "cloneurl": "",
          "returnurl": "",
          "targeturl": "api/v1/getWebPageLayout"
      }
  },
  {
      "name": "Delete",
      "buttontype": "common",
      "actiontype": "View",
      "attributes": {
          "recordtypeexists": "",
          "displaytype": "Button",
          "updateurl": "",
          "cloneurl": "",
          "returnurl": "web/v1/lead/leadlist",
          "targeturl": "api/v1/contact/delete"
      }
  },
  {
      "name": "Clone",
      "buttontype": "common",
      "actiontype": "View",
      "attributes": {
          "recordtypeexists": "",
          "displaytype": "Button",
          "updateurl": "",
          "cloneurl": "",
          "returnurl": "",
          "targeturl": "api/v1/getWebPageLayout"
      }
  },{
    "name": "Edit",
    "buttontype": "common",
    "actiontype": "View",
    "attributes": {
        "recordtypeexists": "",
        "displaytype": "Button",
        "updateurl": "",
        "cloneurl": "",
        "returnurl": "",
        "targeturl": "api/v1/getWebPageLayout"
    }
  }
  ]`);

  fieldTypeSelect = [];
  //buttonList = [];

  detailForm = this.fb.group({
    fieldtype: "",
  });

  selectedButtons = [];
  selectedButton = "";
  unSelectedButtons = [];
  onSelect(event: TypeaheadMatch, objectName: string): void {
    if (objectName == "button") {
      this.selectedButton = "";
      this.selectedButtons.push(event.item);
      this.unSelectedButtons = this.unSelectedButtons.filter(
        (eachUnselected) => eachUnselected != event.item
      );
    }
  }

  removeSelectedItem(selectedItem, objectName: string) {
    if (objectName == "button") {
      this.unSelectedButtons.push(selectedItem);
      this.selectedButtons = this.selectedButtons.filter(
        (eachUnselected) => eachUnselected != selectedItem
      );
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.selectedButtons,
      event.previousIndex,
      event.currentIndex
    );
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    this.unSelectedButtons = JSON.parse(JSON.stringify(this.buttonList));

    //create field type picklist from fieldtypes
    for (let i = 0; i < this.appConfig.fieldTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.fieldTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.fieldTypeSelect.push({
        value: this.appConfig.fieldTypes[i],
        label: strLabel,
      });
    }
  }
}
